import styled from 'styled-components';

export const GridWrapper = styled.div`
    display: grid;
    grid-template-columns: [first-col] minmax(250px, 1fr) minmax(100px, 200px) minmax(100px, 200px) minmax(100px, 200px) [last-col] 130px;
`;

export const LoadingContainer = styled.div`
    color: #172b4d;
    margin: 0;
    padding: 0;
    height: 100vh;
`;

export const TableHeader = styled.span`
    color: #5e6c84;
    font-size: 12px;
    font-weight: 600;
`;
